import { Component, Input, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Global } from "src/app/global";
import { ApiService } from "src/app/service/apiServices";
import Swal from "sweetalert2";

@Component({
  selector: "app-modal-previne-brasil-hipertensao",
  templateUrl: "./modal-previne-brasil-hipertensao.component.html",
  styleUrls: ["./modal-previne-brasil-hipertensao.component.css"],
})
export class ModalPrevineBrasilHipertensaoComponent implements OnInit {
  @Input() listaDeRegistros: any[];
  @Input() tipoIndicador: string;
  @Input() exibirPaginacao: boolean = false;
  @Input() rotaApi?: string = "";
  @Input() nomeAba?: string = "";

  loading: boolean = false;
  itensPorPagina: number = 10;
  totalPagina: number = 1;
  pagina: number = 1;
  quantidadeTotal: number = 0;
  constructor(
    public global: Global,
    public service: ApiService,
    public bsModalRef: BsModalRef,
  ) {}

  ngOnInit() {
    console.log( this.listaDeRegistros);
    if (this.listaDeRegistros.length > 16 && this.rotaApi !== "") {
      this.exibirPaginacao = true;
      this.totalPagina = Math.ceil(this.quantidadeTotal / this.itensPorPagina);
    }
  }
  limparCaracteresCidCiap(texto): string {
    if (texto === undefined || texto.length > 1)
      return texto.slice(1, -1).replace(/\|/g, " - ");

    return " - ";
  }
  pesquisar(pagina: number = 1) {
    this.pagina = pagina;
    Swal.fire({
      title: "Favor aguarde",
      allowOutsideClick: false,
      allowEscapeKey: false,
    });

    Swal.showLoading();
    var url = `${this.rotaApi}&skip=${this.pagina}&take=${this.itensPorPagina}`;

    this.service
      .Get(url)
      .then((res: any) => {
        this.listaDeRegistros = res.conteudo;

        this.totalPagina = Math.ceil(
          res.quantidade_total / this.itensPorPagina,
        );
        this.loading = false;

        Swal.close();
      })
      .catch((err) => {
        Swal.close();
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro na busca.",
          icon: "error",
        });
      });
  }
  voltarPagina = () => {
    if (this.pagina >= 2) this.pagina = this.pagina - 1;
    this.pesquisar(this.pagina);
  };

  exibirProficional() {
    if (
      this.tipoIndicador === "Atendimento" ||
      this.tipoIndicador === "ConsultaPuerperio" ||
      this.tipoIndicador === "SeteConsulta" ||
      this.tipoIndicador === "ConsultaPreNatal" ||
      this.tipoIndicador === "PrimeiraConsulta" ||
      this.tipoIndicador === "NoveConsulta" ||
      this.tipoIndicador === "Odontologico" ||
      this.tipoIndicador === "Detalhe" ||
      this.tipoIndicador === "DetalheOdontoExodontia" ||
      this.tipoIndicador === "DetalheOdontoConcluido" ||
      this.tipoIndicador === "DetalheProcedimentoPreventivo" ||
      this.tipoIndicador === "DetalheTratamentoRestaurador"
    ) {
      return true;
    } else {
      return false;
    }
  }
  exibirProcedimento() {
    if (
      this.tipoIndicador === "PressaoArterial" ||
      this.tipoIndicador === "Antropometria" ||
      this.tipoIndicador === "Antropometrica" ||
      this.tipoIndicador === "ExamePrimeiro" ||
      this.tipoIndicador === "ExameTerceiro" ||
      this.tipoIndicador === "DetalheOdontoExodontia" ||
      this.tipoIndicador === "DetalheOdontoConcluido" ||
      this.tipoIndicador === "DetalheProcedimentoPreventivo" ||
      this.tipoIndicador === "DetalheTratamentoRestaurador"
    ) {
      return true;
    } else {
      return false;
    }
  }
  exibirQtdETipoProcedimento() {
    if (
      this.tipoIndicador === "DetalheOdontoExodontia" ||
      this.tipoIndicador === "DetalheProcedimentoPreventivo" ||
      this.tipoIndicador === "DetalheTratamentoRestaurador"
    ) {
      return true;
    } else {
      return false;
    }
  }

  limparProcedimento(procedimentos: string) {
    return procedimentos
      .replace(/^(\|)/, "")
      .replace(/(\|)$/, "")
      .replace(/\|/g, " - ");
  }
  exibirTipoProcedimento(registro: any) {
    let tipoProcedimento = "";

    switch (true) {
      case registro.procedimento_preventivo === true &&
        registro.procedimento_exodontia === true:
        tipoProcedimento += "Procedimento Preventivo - Procedimento Exodontia";
        break;

      case registro.procedimento_preventivo === true &&
        registro.procedimento_exodontia === false:
        tipoProcedimento += "Procedimento Preventivo";
        break;

      case registro.procedimento_preventivo === false &&
        registro.procedimento_exodontia === true:
        tipoProcedimento += "Procedimento Exodontia";
        break;

      case registro.procedimento_restaurador === true &&
        registro.procedimento_restaurador_atraumatico === true:
        tipoProcedimento +=
          "Procedimento Restaurador - Procedimento Restaurador Atraumático";
        break;

      case registro.procedimento_restaurador === true &&
        registro.procedimento_restaurador_atraumatico === false:
        tipoProcedimento += "Procedimento Restaurador";
        break;

      case registro.procedimento_restaurador === false &&
        registro.procedimento_restaurador_atraumatico === true:
        tipoProcedimento += "Procedimento Restaurador Atraumático";
        break;

      case registro.procedimento_preventivo === true:
        tipoProcedimento += "Procedimento Preventivo";
        break;

      default:
        tipoProcedimento += " - ";
    }

    return tipoProcedimento;
  }
}
